import React from 'react';
export function FooterSection() {
  return <footer className="py-8 px-4 border-t border-cyan-500/10 bg-[#060a14] text-center" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <p className="text-gray-500 text-sm mb-2" data-id="element-56">
          © {new Date().getFullYear()} El Código del Sueño Profundo. Todos los
          derechos reservados.
        </p>
        <p className="text-gray-600 text-xs max-w-2xl mx-auto" data-id="element-57">
          Descargo de responsabilidad: Este producto no sustituye el consejo
          médico profesional. Consulte a su médico antes de realizar cambios
          significativos en su estilo de vida o si padece trastornos graves del
          sueño.
        </p>
      </div>
    </footer>;
}